
import {getBonusesPersonal} from '../api/getBonusesPersonal';
import {setGetBonusesPersonalAction} from '../action';

const setGetBonusesPersonal = () => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getBonusesPersonal();

            if (data.status === 'success') {
                dispatch(setGetBonusesPersonalAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetBonusesPersonal
}